/* @flow */

const focusSiblingSection = (container: HTMLElement, key: string) => {
  const currentSection = container.closest('.section');
  if (!(currentSection instanceof HTMLElement)) {
    return;
  }

  // Query sections (including modal sections)
  const allSections = Array.from(document.querySelectorAll<HTMLElement>('.section:not(.placeholder):not(.hidden)'));

  const sectionIndex = allSections.indexOf(currentSection);
  if (sectionIndex === -1) {
    return;
  }

  const targetSection = key === 'ArrowUp' ? allSections[sectionIndex - 1] : allSections[sectionIndex + 1];

  if (targetSection) {
    const targetTile = targetSection.querySelector('.sectionItem[tabindex="0"]');

    if (targetTile instanceof HTMLElement) {
      targetTile.focus();
      targetTile.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    }
  }
};

export { focusSiblingSection };
